var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 29,
    rx: 5,
    fill: "#128B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5625 17.1375C5.87316 17.1375 6.125 17.3894 6.125 17.7V20.5125C6.125 21.1338 6.62868 21.6375 7.25 21.6375H20.75C21.3713 21.6375 21.875 21.1338 21.875 20.5125V17.7C21.875 17.3894 22.1268 17.1375 22.4375 17.1375C22.7482 17.1375 23 17.3894 23 17.7V20.5125C23 21.7552 21.9926 22.7625 20.75 22.7625H7.25C6.00736 22.7625 5 21.7552 5 20.5125V17.7C5 17.3894 5.25184 17.1375 5.5625 17.1375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6023 19.3352C13.8219 19.5549 14.1781 19.5549 14.3977 19.3352L17.7727 15.9602C17.9924 15.7406 17.9924 15.3844 17.7727 15.1648C17.5531 14.9451 17.1969 14.9451 16.9773 15.1648L14.5625 17.5795V7.6875C14.5625 7.37684 14.3107 7.125 14 7.125C13.6893 7.125 13.4375 7.37684 13.4375 7.6875V17.5795L11.0227 15.1648C10.8031 14.9451 10.4469 14.9451 10.2273 15.1648C10.0076 15.3844 10.0076 15.7406 10.2273 15.9602L13.6023 19.3352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTable);
export default __webpack_public_path__ + "static/media/download-table.337802bce2bb49ef3c610980820007b5.svg";
export { ForwardRef as ReactComponent };